












import {computed, defineComponent, PropType} from "@vue/composition-api";
import {FormErrorResponse} from "@tool/Helpers/useFormHelper";

export default defineComponent({
    props: {
        error: {
            type: Object as PropType<FormErrorResponse>,
            required: false
        },
        attributes: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props) {

        const beautifyProperty = (property: string) => {
            if (property === '') {
                return ''
            }

            if (property in props.attributes) {
                if (props.attributes[property] === '') {
                    return '';
                }
                return `${props.attributes[property]}: `;
            }

            return `${property}: `;
        };

        const errorsAreArray = computed(() => {
            if(!props.error || !props.error.errors) {
                return false;
            }

            const arrayKeys = Object.keys(props.error.errors);

            if (arrayKeys.length === 0) {
                return false;
            }

            // @ts-ignore
            return Array.isArray(props.error.errors[arrayKeys[0]]);
        })

        return { beautifyProperty, errorsAreArray}

    },
})
